"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSevenBannerSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    sectionDiv0Div0ClassName?: string;
    /** Default: "0.2s" */
    sectionDiv0Div0Div0Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "all_routes.search1" */
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Expert cardiologists, modern technology, and compassionate heart care" */
    sectionDiv0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "Cardiac Treatment" */
    sectionDiv0Div0Div0Div0Div0H10H1Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Redefining Modern" */
    sectionDiv0Div0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "0.2s" */
    sectionDiv0Div0Div0Div0Div1DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "banner" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-03.png" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Play Video" */
    sectionDiv1DivText?: ReactNode;
    /** Default: "" */
    sectionDiv1Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv1Link0LinkHref?: string;
    sectionDiv1Link0LinkVisible?: boolean;
    sectionDiv1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-08.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-09.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-10.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeSevenBannerSectionGenerated: FC<HomeSevenBannerSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkHref = "all_routes.search1",
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkText = "View All Services",
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0Div0Div0P0PText = "Expert cardiologists, modern technology, and compassionate heart care",
    sectionDiv0Div0Div0Div0Div0H10H1Text = "Cardiac Treatment",
    sectionDiv0Div0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0Div0H10Span0SpanText = "Redefining Modern",
    sectionDiv0Div0Div0Div0Div1DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-03.png",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv1DivText = "Play Video",
    sectionDiv1Link0LinkDataFancybox = "",
    sectionDiv1Link0LinkHref = "#",
    sectionDiv1Link0LinkVisible,
    sectionDiv1Link0LinkRenderer,
    sectionDiv1Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-08.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-09.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-10.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionDiv0Div0ClassName,
}) => {
    return (
        <>
            <section className="banner-section-seven">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row"}>
                        <div className="col-xl-10 mx-auto">
                            <div className="banner-content wow fadeInUp" data-wow-delay={sectionDiv0Div0Div0Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                <div>
                                    {renderNode(sectionDiv0Div0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0Div0H10H1Renderer, (
                                        <h1 {...(sectionDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                            <span>{sectionDiv0Div0Div0Div0Div0H10Span0SpanText}</span>
                                            {sectionDiv0Div0Div0Div0Div0H10H1Text}
                                        </h1>
                                    ))}
                                    <div className="banner-info">
                                        <p className="sub-title">{sectionDiv0Div0Div0Div0Div0Div0P0PText}</p>
                                        {renderNode(sectionDiv0Div0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                            <SmartLink href={sectionDiv0Div0Div0Div0Div0Div0Link0LinkHref} className="btn btn-white theme-7-btn" {...(sectionDiv0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                                {sectionDiv0Div0Div0Div0Div0Div0Link0LinkText}
                                                <span className="icon">
                                                    <i className="isax isax-arrow-right-3" />
                                                </span>
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                                <div className="banner-img wow fadeInUp" data-wow-delay={sectionDiv0Div0Div0Div0Div1DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div0Div0Div1DivDataWowDuration}>
                                    {renderNode(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc} className="img-fluid banner-image" alt={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="banner-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="banner-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="banner-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
                ))}
                <div className="video-icon">
                    {renderNode(sectionDiv1Link0LinkVisible, sectionDiv1Link0LinkRenderer, (
                        <SmartLink href={sectionDiv1Link0LinkHref} data-fancybox={sectionDiv1Link0LinkDataFancybox} {...(sectionDiv1Link0LinkProps ?? {})}>
                            <i className="isax isax-play" />
                        </SmartLink>
                    ))}
                    {sectionDiv1DivText}
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSevenBannerSectionGenerated;
